import { ArticleText } from "~/components/article-text"
import { QueryBoundary } from "~/components/query-boundary"
import { TitleHeader } from "~/components/title-header"
import { useUserAgreement } from "~/features/user-agreement/hooks/use-user-agreement"
import { usePrivacyPolicy } from "../hooks/use-privacy-policy"

export type LegalDocumentKind = "agreement" | "privacy"

const TITLES: Record<LegalDocumentKind, string> = {
  agreement: "Условия использования",
  privacy: "Политика конфиденциальности",
}

function AgreementContent() {
  const { data } = useUserAgreement()
  return <ArticleText text={data.content} />
}

function PrivacyContent() {
  const { data } = usePrivacyPolicy()
  return <ArticleText text={data.content} />
}

interface Props {
  kind: LegalDocumentKind
}

export function LegalDocumentPage({ kind }: Props) {
  return (
    <div className="flex flex-col">
      <TitleHeader title={TITLES[kind]} />
      <div className="bg-card py-s pb-safe-ios-m">
        <QueryBoundary>
          {kind === "agreement" ? <AgreementContent /> : <PrivacyContent />}
        </QueryBoundary>
      </div>
    </div>
  )
}
